<template>
<v-dialog v-model="visible" :scrollable="scrollable" :persistent="persistent" :max-width="width" @keydown.esc="visible=false">
  <v-card v-if="visible" :min-height="min_height">
    <v-toolbar flat dense>
      <v-toolbar-title>
        <slot name="title"></slot>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="menu"></slot>
      <v-btn icon color="grey" @click="$emit('setting')" v-if="setting">
        <v-icon>mdi-settings</v-icon>
      </v-btn>
      <v-btn icon color="grey" @click="visible=false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="py-0">
      <slot></slot>
    </v-card-text>
    <v-card-actions>
      <slot name="actions"></slot>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import BaseDialog from '@/components/utils/dialog/BaseDialog'

export default {
  name: 'Dialog',
  mixins: [BaseDialog],
  props: {
    scrollable: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 400
    },
    setting: {
      type: Boolean,
      default: false
    },
    min_height: {
      type: Number,
      default: 180
    }
  }
}
</script>
